import colormap from "colormap";

import { type IColorPalette, PaletteType } from "models/colorPalette";

// Enough stops to read as a continuous scale in the palette list, and enough to
// satisfy every map in COMPATIBLE_COLORMAP_NAMES — several (plasma, viridis,
// inferno) refuse fewer than nine shades.
const GENERATED_PALETTE_SHADES = 12;

/**
 * Builds a palette object from a `colormap` package name (see
 * COMPATIBLE_COLORMAP_NAMES). Returns null when the package does not recognise
 * the name, so callers can filter it out.
 *
 * Single source of truth for these generated palettes: the palette list offers
 * them to the user and rig/frac layers default to one, and both must produce
 * identical colours for the same name.
 */
export function buildColormapPalette(name: string): Nullable<IColorPalette> {
  try {
    const colors = colormap({
      colormap: name,
      nshades: GENERATED_PALETTE_SHADES,
      format: "hex",
      alpha: 1
    });
    return {
      id: `generated-${name}`,
      name: name.charAt(0).toUpperCase() + name.slice(1),
      colors,
      thickness: [],
      shared: false,
      paletteType: PaletteType.Continuous,
      reverse: false
    };
  } catch {
    return null;
  }
}
